import { render, staticRenderFns } from "./TestLinks.vue?vue&type=template&id=5e97755d&scoped=true"
import script from "./TestLinks.vue?vue&type=script&lang=js"
export * from "./TestLinks.vue?vue&type=script&lang=js"
import style0 from "./TestLinks.vue?vue&type=style&index=0&id=5e97755d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e97755d",
  null
  
)

export default component.exports